import { connect } from 'react-redux'
import { hasSubmitSucceeded } from 'redux-form'
import { compose, withProps, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import withViewHide from 'components/common/hoc/withViewHide'
import BOTAppointmentSummary from './BOTAppointmentSummary'
import { getAppointments } from 'selectors/getAppointments'
import { getPageLocation } from 'selectors'
import { getCurrentStoreEnableAppointmentFlag, getCurrentStore } from 'selectors/getCurrentStore'
import { getServicesDisplayNames, getSelectedVehicle, getSelectedTime } from './selectors'
import { getValues as getFormValues } from 'components/Appointment/selectors'
import { generateAddress } from 'helpers/storeLocator'
import { getIsOnlineAppointment, getIsQuotePage, isDateInAppointments, getUserVehicleName } from './helpers'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import { setIsTrailer } from '../actions'
import {
  QUICK_APPOINTMENT__SUMMERY_PRODUCT_TITLE,
  QUOTE_SUMMERY_PRODUCT_TITLE
} from '../constants'
import { APPOINTMENT_FORM_NAME, GENERAL_SOURCE, YMME_NAME } from 'constant'
import { showNewShopTiresModal } from '../../NewShopTiresModal/actions'

const mapStateToProps = (state) => {
  const {
    catalogRefIds,
    activeVehicleId,
    appointmentDate
  } = getFormValues(state) || {}

  const myStore = getCurrentStore(state)
  const {
    servicesList,
    vehicles,
    quoteProductsAndCervices,
    isTrailer,
    dates
  } = getAppointments(state)

  const {
    date = {},
    time = {}
  } = !!appointmentDate && isDateInAppointments({ appointmentDate, dates }) ? appointmentDate : {}

  return {
    hasStore: Boolean(myStore),
    appointmentEnable: getCurrentStoreEnableAppointmentFlag(state),
    isOnlineAppointment: getIsOnlineAppointment(getPageLocation(state)),
    isQuotePage: getIsQuotePage(getPageLocation(state)),
    selectedServices: (catalogRefIds && catalogRefIds.length) ?
      getServicesDisplayNames({ servicesList, catalogRefIds }) :
      quoteProductsAndCervices,
    selectedVehicle: getSelectedVehicle({ vehicles, activeVehicleId, isTrailer }) || getUserVehicleName(vehicles),
    selectedStore: generateAddress(myStore || {}),
    ...getSelectedTime({ date, time: time || {}}),
    hasSubmitSucceeded: hasSubmitSucceeded(APPOINTMENT_FORM_NAME)(state)
  }
}

const withLifecycle = lifecycle({
  componentDidMount() {
    const { setIsTrailer, isOnlineAppointment } = this.props

    if (!isOnlineAppointment) {
      setIsTrailer(false)
    }
  }
})

const withSummaryProps = withProps(({
  isOnlineAppointment,
  selectedVehicle,
  selectedStore,
  selectedServices,
  selectedDateTime,
  showNewShopTiresModal
}) => ({
  productPlaceholder: isOnlineAppointment ?
    QUICK_APPOINTMENT__SUMMERY_PRODUCT_TITLE : QUOTE_SUMMERY_PRODUCT_TITLE,
  isSelectionValid: Boolean(
    (!isOnlineAppointment || selectedServices) &&
    selectedVehicle && selectedStore && selectedDateTime
  ),
  addVehicle: () => showNewShopTiresModal({
    isOnlyVehicle: true,
    ymmeName: YMME_NAME,
    withShowConfirmTireSizeModal: true,
    source: GENERAL_SOURCE
  })
}))

export default compose(
  withType({
    type: 'BOTAppointmentSummary', placeholders: ['button']
  }),
  connect(mapStateToProps, {
    showStoreLocatorModalInAppointmentMode,
    setIsTrailer,
    showNewShopTiresModal
  }),
  withLifecycle,
  withViewHide(({ appointmentEnable, hasStore }) => hasStore && !appointmentEnable),
  withSummaryProps
)(BOTAppointmentSummary)
